"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Item = void 0;
var items_1 = require("../../requests/items");
var EventEmitter_1 = require("../../services/EventEmitter/EventEmitter");
var utils_1 = require("../../services/utils");
var collection_1 = require("../collection/collection");
var Item = /** @class */ (function (_super) {
    __extends(Item, _super);
    function Item(_collection, attributes) {
        var _this = _super.call(this) || this;
        _this.type = 'image';
        _this.title = '';
        _this.tags = [];
        _this.collection = _collection;
        _this._toDefaults();
        if (attributes) {
            _this._mergeProperties(attributes);
        }
        collection_1.hideProps(['_events', '_maxListeners'], _this);
        return _this;
    }
    Item.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.collection.emit("item." + event, this);
        return _super.prototype.emit.apply(this, __spreadArrays([event], args));
    };
    Item.prototype.save = function () {
        return this.callWithOrWithoutId(items_1.itemsRequests.update, items_1.itemsRequests.createAsLast);
    };
    Item.prototype.moveToStart = function () {
        return this.callWithOrWithoutId(items_1.itemsRequests.moveToStart, items_1.itemsRequests.createAsFirst);
    };
    Item.prototype.moveToEnd = function () {
        return this.callWithOrWithoutId(items_1.itemsRequests.moveToEnd, items_1.itemsRequests.createAsLast);
    };
    Item.prototype.moveBefore = function (beforeItemOrId) {
        return this.callWithOrWithoutId(items_1.itemsRequests.moveBefore, items_1.itemsRequests.createBefore, beforeItemOrId);
    };
    Item.prototype.moveAfter = function (afterItemOrId) {
        return this.callWithOrWithoutId(items_1.itemsRequests.moveAfter, items_1.itemsRequests.createAfter, afterItemOrId);
    };
    Item.prototype.delete = function () {
        var _this = this;
        return items_1.itemsRequests.delete(this.collection, [this]).then(utils_1.tap(function () {
            var index = _this.collection.items.indexOf(_this);
            if (index > -1) {
                _this.collection.items.splice(index, 1);
            }
        }));
    };
    Item.prototype.toJSON = function () {
        return {
            id: this.id,
            type: this.type,
            title: this.title,
            tags: this.tags,
            public_properties: this.publicProperties,
            private_properties: this.privateProperties,
        };
    };
    /**
     * @param serverData
     * @private
     */
    Item.prototype._mergeProperties = function (serverData) {
        if (serverData instanceof Array) {
            serverData = serverData[0];
        }
        Object.assign(this, utils_1.toClientModel(serverData));
    };
    Item.prototype.callWithOrWithoutId = function (withIdRequest, withoutIdRequest, opt) {
        var _this = this;
        var promise;
        promise = this.id
            ? withIdRequest(this.collection, [this.toJSON()], opt)
            : withoutIdRequest(this.collection, [this.toJSON()], opt);
        return promise.then(function (res) {
            _this._mergeProperties(res);
            return _this;
        });
    };
    Item.prototype._toDefaults = function () {
        this.id = void 0; // GUID assigned on item creation
        this.type = 'image'; // Defines type of item's content (for example; "audio"; "image"; "video"; etc.)
        this.title = ''; // Title of the item (may be empty)
        this.tags = [];
        this.sortOrder = void 0; // RawItem's position in collection
        this.publicProperties = {};
        this.privateProperties = {};
    };
    __decorate([
        EventEmitter_1.withEventEmitter('save'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Item.prototype, "save", null);
    __decorate([
        EventEmitter_1.withEventEmitter('moveToStart'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Item.prototype, "moveToStart", null);
    __decorate([
        EventEmitter_1.withEventEmitter('moveToEnd'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Item.prototype, "moveToEnd", null);
    __decorate([
        EventEmitter_1.withEventEmitter('moveBefore'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Item.prototype, "moveBefore", null);
    __decorate([
        EventEmitter_1.withEventEmitter('moveAfter'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], Item.prototype, "moveAfter", null);
    __decorate([
        EventEmitter_1.withEventEmitter('delete'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], Item.prototype, "delete", null);
    return Item;
}(EventEmitter_1.EventEmitter));
exports.Item = Item;
//# sourceMappingURL=item.js.map